





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class InputNumber extends Vue {
	@Prop({ type: [String, Number], required: true })
	value!: string | number;

	@Prop({ type: String, required: false, default: '' })
	label!: string;

	@Prop({ type: String, required: true })
	name!: string;

	@Prop({ type: [String, Object], required: false, default: '' })
	rules!: string | object;

	@Prop({ type: String, required: false, default: '#000' })
	color!: string;

	@Prop({ type: Boolean, required: false, default: false })
	autofocus!: boolean;

	@Prop({ type: Boolean, required: false, default: true })
	showErrors!: boolean;

	@Prop({ type: Number, default: -Infinity })
	min!: number;

	@Prop({ type: Number, default: Infinity })
	max!: number;

	get id() {
	    return this.name + new Date().valueOf();
	}

	get listeners() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { input, ...listeners } = this.$listeners;
	    return listeners;
	}

	get getValue(): number {
	    const val = this.value as any;
	    if (!val || isNaN(val)) return 0;
	    return parseFloat(val);
	}

	Reduce() {
	    const current = this.getValue || 0;
	    const next = current - 1;
	    if (next >= this.min) {
	        this.$emit('input', next);
	    }
	}

	Increase() {
	    const current = this.getValue || 0;
	    const next = current + 1;
	    if (next <= this.max) {
	        this.$emit('input', next);
	    }
	}

	changedInput(event: any) {
	    let val: any = event.target.value;
	    if (!isNaN(val) && val !== '') {
	        val = parseFloat(val);
	    } else {
	        val = 0;
	    }

	    this.$emit('input', val);
	}

	checkConstraints() {
	    if (this.value < this.min) {
	        this.$emit('input', this.min);
	    }

	    if (this.value > this.max) {
	        this.$emit('input', this.max);
	    }
	}
}
